(function () {
  'use strict';

  function pad2(n) {
    var v = Math.max(0, Math.min(99, Math.floor(n)));
    return (v < 10 ? '0' : '') + v;
  }

  function parseEnd(raw) {
    if (!raw || !String(raw).trim()) return null;
    var t = Date.parse(String(raw).trim().replace(' ', 'T'));
    return Number.isNaN(t) ? null : t;
  }

  function tick(root) {
    var end = parseEnd(root.getAttribute('data-end'));
    var digits = root.querySelectorAll('.mooka-countdown__digit');
    var expiredEl = root.querySelector('[data-countdown-expired]');
    var hideExpired = root.getAttribute('data-hide-expired') === 'true';

    if (!end || digits.length !== 8) return;

    var ms = end - Date.now();
    if (ms <= 0) {
      root.setAttribute('data-state', 'expired');
      digits.forEach(function (el) { el.textContent = '0'; });
      if (expiredEl) expiredEl.hidden = false;
      return;
    }

    root.removeAttribute('data-state');
    if (expiredEl) expiredEl.hidden = true;

    var totalSec = Math.floor(ms / 1000);
    var days = Math.floor(totalSec / 86400);
    var rem = totalSec % 86400;
    var hours = Math.floor(rem / 3600);
    rem = rem % 3600;
    var minutes = Math.floor(rem / 60);
    var seconds = rem % 60;
    var chars = (pad2(days) + pad2(hours) + pad2(minutes) + pad2(seconds)).split('');

    digits.forEach(function (el, i) {
      el.textContent = chars[i] || '0';
    });
  }

  function init() {
    document.querySelectorAll('[data-mooka-countdown]').forEach(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setInterval(init, 1000);
  document.addEventListener('shopify:section:load', init);
})();
